/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function SwatchBookFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="swatch-book-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M2.75 5.5C2.783 4.794 3.099 4.012 3.555 3.555C4.012 3.099 4.794 2.783 5.5 2.75L7.5 2.75C8.206 2.783 8.988 3.099 9.445 3.555C9.901 4.012 10.217 4.794 10.25 5.5L10.25 17.5C10.217 18.482 9.789 19.514 9.152 20.152C8.514 20.789 7.482 21.25 6.5 21.25C5.518 21.25 4.486 20.789 3.848 20.152C3.211 19.514 2.783 18.482 2.75 17.5L2.75 5.5ZM6.5 17C5.948 17 5.5 17.448 5.5 18C5.5 18.552 5.948 19 6.5 19C7.052 19 7.5 18.552 7.5 18C7.5 17.448 7.052 17 6.5 17Z" data-tinysvg-shape="compound-path" fillRule="evenodd" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M9.5 10.257L12.864 6.893C13.645 6.112 14.911 6.112 15.692 6.893L17.107 8.308C17.888 9.089 17.888 10.355 17.107 11.136L8.621 19.621" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M13.743 14.5L18.5 14.5C19.605 14.5 20.5 15.395 20.5 16.5L20.5 18.5C20.5 19.605 19.605 20.5 18.5 20.5L6.5 20.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
